import type { HomeContentResult, ApiResponse, PmsProductCategory, PmsProduct } from '~/types'
import type { NitroFetchRequest, $Fetch } from 'nitropack'
export const homeRepository = () => ({
  async getHomeContent() {
    return await useAPI<ApiResponse<HomeContentResult>>('/home/content')

  },

  async getCategories(id: string) {
    return await useAPI<ApiResponse<PmsProductCategory[]>>(
      `/home/productCateList/${id}`
    );
  },

  async getCategoriesFull() {
    return await useAPIFetch<ApiResponse<PmsProductCategory[]>>(
      '/home/productCateListFull'
    );
  },

  async getRecommendProductList(pageNum: number, pageSize: number) {
    return await useAPI<ApiResponse<PmsProduct[]>>(
      '/home/recommendProductList',
      {
        params: { pageNum, pageSize },
      }
    );
  },
})